module.exports = __webpack_public_path__ + "img/Salvador-Espinosa-.3dd4a85c.png";